module.exports = __webpack_public_path__ + "static/media/backBtn.795d3a30.svg";